<template>

  <span class="phone-number">
    <input v-model="areaCode" data-modelName="areaCode" v-on:keyup="checkLengthAndTab" v-on:keyup.enter="onEnterClick()" maxlength="3" type="number" class="sleek-input phone-number-input area-code">
    <input v-model="prefix" data-modelName="prefix" v-on:keyup="checkLengthAndTab" v-on:keyup.enter="onEnterClick()" maxlength="3" type="number" class="sleek-input phone-number-input">
    <input v-model="lineNumber" data-modelName="lineNumber" v-on:keyup="checkLineNumberLength" v-on:keyup.enter="onEnterClick()" maxlength="4" type="number" class="sleek-input phone-number-input">
  </span>

</template>

<script>

export default {
  name: 'PhoneNumber',
  props: {
    setPhoneNumberValid: {
      type: Function,
      default: () => { return {} }
    },
    setPhoneNumberInvalid: {
      type: Function,
      default: () => { return {} }
    }
  },
  data () {
    return {
      areaCode:     '',
      prefix:       '',
      lineNumber:   ''
    }
  },
  computed: {
    fullPhoneNumber () {
      return '+1' + this.areaCode + this.prefix + this.lineNumber
    }
  },
  mounted () {
    this.$el.querySelector('input.area-code').focus()
  },
  methods: {
    validatePhoneNumber () {
      if (this.areaCode.length === 3 && this.prefix.length === 3 && this.lineNumber.length === 4) {
        this.setPhoneNumberValid()
      } else {
        this.setPhoneNumberInvalid()
      }
    },
    checkLengthAndTab (event) {
      let maxLength = 3
      let length = event.target.value.length
      if (length === maxLength) {
        event.target.nextElementSibling.focus()
        event.target.value = event.target.value.substring(0, maxLength)
      } else {
        let modelName = event.target.getAttribute('data-modelName')
        let subString = event.target.value.substring(0, maxLength)
        this[modelName] = subString                                         // This fixes issue with user going back and inputting another number
        event.target.value = event.target.value.substring(0, maxLength)
      }
      this.validatePhoneNumber()
    },
    checkLineNumberLength (event) {
      let maxLength = 4
      let length = event.target.value.length
      if (length === maxLength) {
        event.target.blur()
        event.target.value = event.target.value.substring(0, maxLength)
      } else {
        let modelName = event.target.getAttribute('data-modelName')
        let subString = event.target.value.substring(0, maxLength)
        this[modelName] = subString                                         // This fixes issue with user going back and inputting another number
        event.target.value = event.target.value.substring(0, maxLength)
      }
      this.validatePhoneNumber()
    },
    clearPhoneNumber () {
      this.areaCode     = ''
      this.prefix       = ''
      this.lineNumber   = ''
      this.validatePhoneNumber()
    }
  }
}
</script>

<style lang="scss" scoped>

.phone-number {
  text-align:                 left;
  position:                   relative;

  /* Removes the increment from number input */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance:     none;
      -moz-appearance:        none;
      appearance:             none;
      margin:                 0;
  }

  .phone-number-input {
    font-size:                1.5em;
    margin-left:              0.5em;
    max-width:                2.5em;
    text-align:               center;
    font-family:              'Bodoni';
    border-radius:            0;
    padding:                  0;

    &:first-of-type {
      margin-left:            0;
    }
  }

  .sleek-button {
    font-size:                1em;
    padding:                  0.5em;
    width:                    10em;
    text-align:               center;
    display:                  block;
    margin-top:               1.5em;
  }
}

/* Portrait tablet to landscape and desktop */
@media (max-width: 768px) {

  .phone-number {

    .content {
      padding:                    1.5em 2em;

      .content-command {
        display:                  block;
        font-size:                1em;
        margin-top:               1em;
      }

      .phone-number-input {
        margin-left:              0.5em;
        font-size:                1.5em;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/PhoneNumber.vue